import { AdminPageLayout } from "@/features/admin/components/AdminPageLayout";
import { validateCreateUserWizardSearch } from "@/features/admin/utils/createUserWizard";
import { useNav } from "@/utils/nav";
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/users/create-user")({
    validateSearch: validateCreateUserWizardSearch,
    component: CreateUserWizardLayout,
});

function CreateUserWizardLayout() {
    useNav([
        { label: "Admin", route: { to: "/admin" } },
        { label: "Create User", route: { to: "/users/create-user/details" } },
    ]);

    return (
        <AdminPageLayout
            title="Create user"
            description="Walk through identity, organisations, access, templates, billing, then sign in as the user."
            maxWidthClassName="max-w-3xl"
        >
            <Outlet />
        </AdminPageLayout>
    );
}
